import { render, staticRenderFns } from "./editProductItem.vue?vue&type=template&id=4d003aed&scoped=true&"
import script from "./editProductItem.vue?vue&type=script&lang=js&"
export * from "./editProductItem.vue?vue&type=script&lang=js&"
import style0 from "./editProductItem.vue?vue&type=style&index=0&id=4d003aed&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d003aed",
  null
  
)

export default component.exports